<div class="container" loading-spin [isLoading]="isPageLoading" [loadingSize]="'big'" [loadingLevel]="110">
    <tam-splitter splitterBarWidth=3 [useTransition]="300">
        <tam-splitter-panel [size]="sidelistView.middleWidth" [max]="sidelistView.middleMax"
            [min]="sidelistView.middleMin">
            <div tid="note-list-panel" class="list-container">
                <div class="tool-bar">
                    <div class="search-box">
                        <div class="hider" [hidden]="!config||config.hideKeyword">
                            <keyword-search [config]="keywordSearchConfig">
                            </keyword-search>
                        </div>
                        <div class="counter-box">
                            <span>{{fileViewListTotalCount}} items</span>
                        </div>
                    </div>
                </div>
                <div class="list-pane">
                    <top-file-list [config]="fileViewListConfig">
                    </top-file-list>
                </div>
            </div>
        </tam-splitter-panel>
        <tam-splitter-panel [size]="sidelistView.previewWidth" [max]="sidelistView.collapsedpreviewMax"
            [min]="sidelistView.collapsedpreviewMin">
            <div class="thread-detail-box" loading-spin [isLoading]="isThreadDetailLoading" [loadingSize]="'big'">
                <thread-detail *ngIf="!isThreadDetailLoading" [config]="threadDetailConfig">
                </thread-detail>
            </div>
        </tam-splitter-panel>
    </tam-splitter>
</div>